module.exports = __webpack_public_path__ + "static/the-clash-of-the-cultures-f1776fca928c1dc9c51445195fd86bdd.jpg";